/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UpdateAgentScheduleRequest = {
  agentId: string;
  scheduleId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  updateAgentScheduleRequest: components.UpdateAgentScheduleRequest;
};

/** @internal */
export const UpdateAgentScheduleRequest$inboundSchema: z.ZodType<
  UpdateAgentScheduleRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: z.string(),
  schedule_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  UpdateAgentScheduleRequest:
    components.UpdateAgentScheduleRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
    "schedule_id": "scheduleId",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "UpdateAgentScheduleRequest": "updateAgentScheduleRequest",
  });
});
/** @internal */
export type UpdateAgentScheduleRequest$Outbound = {
  agent_id: string;
  schedule_id: string;
  "X-On-Behalf-Of"?: string | undefined;
  UpdateAgentScheduleRequest: components.UpdateAgentScheduleRequest$Outbound;
};

/** @internal */
export const UpdateAgentScheduleRequest$outboundSchema: z.ZodType<
  UpdateAgentScheduleRequest$Outbound,
  z.ZodTypeDef,
  UpdateAgentScheduleRequest
> = z.object({
  agentId: z.string(),
  scheduleId: z.string(),
  xOnBehalfOf: z.string().optional(),
  updateAgentScheduleRequest:
    components.UpdateAgentScheduleRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
    scheduleId: "schedule_id",
    xOnBehalfOf: "X-On-Behalf-Of",
    updateAgentScheduleRequest: "UpdateAgentScheduleRequest",
  });
});

export function updateAgentScheduleRequestToJSON(
  updateAgentScheduleRequest: UpdateAgentScheduleRequest,
): string {
  return JSON.stringify(
    UpdateAgentScheduleRequest$outboundSchema.parse(updateAgentScheduleRequest),
  );
}
export function updateAgentScheduleRequestFromJSON(
  jsonString: string,
): SafeParseResult<UpdateAgentScheduleRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateAgentScheduleRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateAgentScheduleRequest' from JSON`,
  );
}
